<template>
        <div class="VueTables__limit-field">
            <div class="row align-items-center">
                <div class="col-xl-5">
                    <label>Ցուցադրել</label>
                </div>
                <div class="col-xl-7">
                    <multiselect
                        :id="props.selectAttrs.id"
                        v-model="props.selectAttrs.value"
                        :options="props.perPageValues"
                        :searchable="false"
                        :close-on-select="false"
                        :show-labels="false"
                        placeholder="Գին"
                        :value="props.selectAttrs.value"
                        @select="props.selectEvents.change"
                    />
                </div>
            </div>
        </div>
</template>

<script>
    import Multiselect from 'vue-multiselect'
    export default {
        name: "VtPerPageSelector",
        props: ['props'],
        components: { Multiselect },
    }
</script>